import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=9c9119f4&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=9c9119f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9119f4",
  null
  
)

/* custom blocks */
import block0 from "./BlackList.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports